import * as React from 'react'

const MOBILE_BREAKPOINT = 768

/**
 * Match either:
 *   - narrow viewport (any device in portrait phone form factor)
 *   - landscape with limited height (phones in landscape) — iPhone 17 Pro
 *     landscape is ~932×430, height < 600 catches it; iPad landscape height
 *     is ~810–1024, so tablets correctly stay on the desktop layout.
 *
 * Before D-N-035 the query was width-only, so rotating a phone caused the
 * ResponsiveDialog to morph from Drawer → Dialog mid-flow. The orientation
 * + max-height clause keeps phone-landscape on the Drawer surface.
 */
const MOBILE_QUERY =
  `(max-width: ${MOBILE_BREAKPOINT - 1}px), ` +
  '((orientation: landscape) and (max-height: 600px))'

function evaluate(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(MOBILE_QUERY).matches
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(evaluate)

  React.useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    setIsMobile(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
